import Typography from '@material-ui/core/Typography';
import { FC, ReactElement } from 'react';

import { ITeamMemberMapped } from '~/utils/clientAllocation';

import layoutStyles from '../../../shared/components/EditAllocationFormLayout/EditAllocationFormLayout.module.scss';
import useClientAllocationsUpdate from '../../hooks/updateAllocations/useClientAllocationsUpdate';
import useGetClientsGU from '../../../shared/hooks/useGetClientsGU';
import AllocationClientRowItem from '../ClientsRowItem/AllocationClientRowItem';
import AllocationClientsSelectGU from '../SelectFields/AllocationClientsSelectGU';
import useAddAllocationAvailability from '../../hooks/validateAllocations/useAddAllocationAvailability';

interface IProps {
  teamMemberIdx: number;
  teamMember: ITeamMemberMapped;
}

const AllocationClientsListGU: FC<IProps> = ({ teamMemberIdx, teamMember }): ReactElement => {
  const {
    fields: clientsAllocationsFields,
    updateAllocations,
    removeClientAt,
  } = useClientAllocationsUpdate(teamMemberIdx);

  const { loadMore, loading, items: clientOptions } = useGetClientsGU(clientsAllocationsFields);

  useAddAllocationAvailability({
    clientsAllocations: clientsAllocationsFields.map(alloc => ({
      clientId: alloc.clientId,
      teamId: alloc.teamId ?? alloc.team?.id,
    })),
    userId: teamMember.id,
  });

  return (
    <>
      <Typography variant="subtitle1" className={layoutStyles.assignedClientsSectionTitle}>
        Client Allocations
      </Typography>

      <AllocationClientsSelectGU
        loading={loading}
        loadMore={loadMore}
        teamMemberIdx={teamMemberIdx}
        updateAllocations={updateAllocations}
      />

      {clientsAllocationsFields.map((field, clientIdx) => {
        const clientTeams = clientOptions.find(client => client.id === field.clientId)?.teams;

        return (
          <AllocationClientRowItem
            key={field.id}
            field={field}
            clientIdx={clientIdx}
            teamMemberIdx={teamMemberIdx}
            memberId={teamMember.id}
            onRemove={removeClientAt}
            availableClientTeams={clientTeams}
          />
        );
      })}
    </>
  );
};

export default AllocationClientsListGU;
